import { render, staticRenderFns } from "./OffersReport.vue?vue&type=template&id=37d1c32a&scoped=true&"
import script from "./OffersReport.vue?vue&type=script&lang=js&"
export * from "./OffersReport.vue?vue&type=script&lang=js&"
import style0 from "./OffersReport.vue?vue&type=style&index=0&id=37d1c32a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d1c32a",
  null
  
)

export default component.exports